<template>
    <div class="mt-number-wrap">
        <MtTitle title="产品案例" english="INTRODUCE" type="blue"></MtTitle>
        <img data-src="../../static/img/content-img7.png" alt="">
        <img data-src="../../static/img/content-img6.png" alt="">
        <div class="text-content-box">
            <img class="number-bg" data-src="../../static/img/bg-img1.png" alt="">
            <div class="text-content-title">基于走路运动步数的<br>线上虚拟运动社交电商步步挣</div>
            <div class="text-content-subtitle">SPORTS SOCIAL E-COMMERCE EARNS MONEY STEP BY STEP</div>
            <div class="text-content"><span>累计运营1000万用户</span>。<br><br> 使命：让走路步数产生价值<br>愿景：希望看到更多用户因我们而使的生活更健康！ <br><br>【步步挣】积极相应国务院关于印发全民健身计划（2021-2025年）的通知；鼓励上千万用户参与全民健身健步走，开发标准统一的科学运动积分体系：动力币，向每日运动达标的用户发放激励政策，以及兑换商品消费券等福利 <br><br>【步步挣】积极相应国务院关于印发全民健身计划（2021-2025年）的通知：平台每日在线开展全民健身健步走：3000步、4000步、5000步、6000步等虚拟运动；截止2021年8月1日每天服务20万用户。</div>
        </div>
    </div>
</template>
<script>
import MtTitle from '../components/Mt-title'
export default {
    name: 'mt-virtual',
    components: {
        MtTitle
    },
    data(){
        return {

        }
    },
    created(){
        localStorage.setItem('path','./mt_virtual')
        localStorage.setItem('index',2)
    },
    mounted(){
        this.handleScroll()
    },
    methods: {
        handleScroll(){
            const images = document.querySelectorAll("img");
            // 传给IntersectionObserver的回调函数
            // 在目标元素能看见时触发一次，目标元素看不见了时再触发一次
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        const data_src = image.getAttribute("data-src");
                        image.setAttribute("src", data_src);
                        console.log('触发')
                        // 图片被加载后取消观察
                        observer.unobserve(image);
                    }
                });
            });
            images.forEach(image => {
                observer.observe(image);
            });
        }
    }
}
</script>
<style scoped>
.mt-number-wrap > img{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 5vw;
}
.text-content-box{
    width: 86vw;
    margin-left: 7vw;
    margin-top: 20vw;
    position: relative;
}
.number-bg{
    position: absolute;
    top: -8.5vw;
    left: 4.6vw;
    height: 32vw;
}
.text-content-title{
    font-size: 5.91vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 8.13vw;
}
.text-content-subtitle{
    font-size: 3.91vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 5.37vw;
}
.text-content{
    margin-top: 7vw;
    font-size: 3.38vw;
    font-family: PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 6.35vw;
}
.text-content > span{
    font-size: 3.87vw;
    color: #4468E6;
}
</style>


// WEBPACK FOOTER //
// src/pages/mt_virtual.vue